import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import { CircularProgress, Skeleton } from "@mui/material";
import Table from "../../../constants/Table";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { usePermission } from "../../../context/PermissionContext";
import { useNavigate } from "react-router-dom";
import Messages from "../../../constants/Messages";
import InvoiceTempPreview from "../settings/Invoice/InvoiceTempPreview";
import { useAuth } from "../../../context/AuthProvider";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";
import { EditIcon, ShowIcon } from "../../../constants/Icons";

const ProjectListSale = (props) => {
  const { isActive, salesData, isSalesLoading, totalPages, perPage } = props;
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { permission, storeSettings, blockedPermissions } = usePermission();
  const navigate = useNavigate();
  const { updateSettings } = useAuth();

  //   const [isSalesLoading, setIsSalesLoading] = useState(true);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isViewData, setViewData] = useState(null);
  const [buttonLoading, setButtonLoading] = useState({ type: "", id: null });
  const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const [isViewTempModalOpen, setViewTempModalOpen] = useState(false);
  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  //   const [salesData, setSalesData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const handleEdit = async (item) => {
    if (blockedPermissions("SALE:update") || permission === undefined) {
      setButtonLoading({ type: "edit", id: item._id });

      try {
        const data = await handleSaleItems(item._id);

        if (data) {
          if (data.consumeVersion === "CONSUMEV2") {
            navigate("/editsale", { state: data });
          } else {
            navigate("/editsaleold", { state: data });
          }
        }
      } catch (error) {
        console.error("Error loading sale data:", error);
      } finally {
        setButtonLoading({ type: "", id: null });
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleView = async (item) => {
    setButtonLoading({ type: "view", id: item._id });
    try {
      const data = await handleSaleItems(item._id);
      if (data) {
        setViewData(data);
        setViewModalOpen(true);
        setViewTempModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching view data:", error);
    } finally {
      setButtonLoading({ type: "", id: null });
    }
  };

  const handleClose = () => {
    setViewModalOpen(false);
    setViewData(null);
  };

  const handleSetTemplate = async (
    templateId,
    selectTermalOption,
    selectHalfA4Option,
    templateTheme,
    show = true,
  ) => {
    if (!checkNetwork()) return;
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateIdtemplateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id = results.templateId;
      const words = id.split("AND");
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1]);
      setViewTempModalOpen(false);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            signature: results?.signature,
            termsAndConditions: results?.termsAndConditions,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECEIPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };

  const getBgColor = (salemode) => {
    if (!salemode || typeof salemode !== "string") return "bg-label-secondary";
    switch (salemode.toLowerCase()) {
      case "bill":
        return "bg-label-honey";
      case "invoice":
        return "bg-label-moon";
      default:
        return "bg-label-secondary";
    }
  };

  const getBgTxtColor = (salemode) => {
    if (!salemode || typeof salemode !== "string") return "bg-label-secondary";
    switch (salemode.toLowerCase()) {
      case "bill":
        return "bg-label-wave";
      case "invoice":
        return "bg-label-deep-purple";
      default:
        return "bg-label-secondary";
    }
  };

  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "bg-label-success";
      case "cancelled":
        return "bg-label-danger";
      default:
        return "bg-label-secondary";
    }
  };

  useEffect(() => {
    const id = storeSettings?.invoiceSettings?.template?.templateId || "";
    const words = id ? id?.split("AND") : [];
    setSelectedOption(words[0]);
    setSelectTermalOption(words[1]);
  }, []);

  return (
    <>
      <label>List Sale</label>
      {isSalesLoading ? (
        <div className="table-responsive ">
          <table className="table align-middle mb-0">
            <tbody>
              {[...Array(perPage)].map((_, index) => (
                <tr key={index}>
                  {[...Array(8)].map((__, i) => (
                    <td key={i} className="text-center">
                      <Skeleton variant="text" width={i === 0 ? 50 : 100} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : salesData?.length > 0 ? (
        <Table
          loading={isSalesLoading}
          data={salesData}
          onRowClick={(item) => handleView(item)}
          columns={[
            {
              label: "S.No",
              render: (_, index) => <>{index + 1} </>,
            },
            {
              label: "Sale Mode",
              render: (item) =>
                item?.salemode && (
                  <span
                    className={`badge rounded-pill ${getBgColor(
                      item?.salemode,
                    )}`}
                  >
                    {formatTrackMode(item?.salemode)}
                  </span>
                ),
            },
            {
              label: "Sale No",
              render: (item) =>
                item?.salemode && (
                  <span
                    className={`badge rounded-pill ${getBgTxtColor(
                      item?.salemode,
                    )}`}
                  >
                    {item?.saleno}
                  </span>
                ),
            },
            {
              label: "Date",
              render: (item) => (
                <div className="d-flex flex-column">
                  <span className="text-nowrap text-heading fw-medium">
                    {
                      DateConverter?.ISOToDisplayFormat(
                        DateConverter?.convertToTimeZone(
                          item?.saledate,
                          "Asia/Kolkata",
                        ),
                      )?.date
                    }
                  </span>
                </div>
              ),
            },
            {
              label: "Sale Items",
              render: (item) => <> {item?.totalItems || 0} Item(s)</>,
            },
            {
              label: "Grand Total",
              render: (item) => (
                <>
                  ₹
                  {CurrencyConverter.toCurrency(
                    Number(item?.grandtotal) || 0,
                    "INR",
                  )}
                </>
              ),
            },
            {
              label: "Status",
              render: (item) =>
                item?.status && (
                  <span
                    className={`badge rounded-pill ${getColor(item?.status)}`}
                  >
                    {item?.status.charAt(0).toUpperCase() +
                      item?.status.slice(1).toLowerCase()}
                  </span>
                ),
            },
            {
              label: "Actions",
              render: (item) => (
                <div className="order-actions opacity-0 opacity-md-100">
                  <button
                    type="button"
                    className="btn-label-info shadow-none me-2"
                    onClick={() => handleView(item)}
                    disabled={
                      buttonLoading?.id === item?._id &&
                      buttonLoading?.type === "view"
                    }
                  >
                    {buttonLoading?.id === item?._id &&
                    buttonLoading?.type === "view" ? (
                      <CircularProgress size={20} className="text-primary" />
                    ) : (
                      <ShowIcon/>
                    )}
                  </button>
                  {item?.status === "ACTIVE" && (
                    <>
                      <button
                        type="button"
                        className="btn-label-primary shadow-none me-2"
                        onClick={() => handleEdit(item)}
                        disabled={
                          buttonLoading?.id === item?._id &&
                          buttonLoading?.type === "edit"
                        }
                      >
                        {buttonLoading?.id === item?._id &&
                        buttonLoading?.type === "edit" ? (
                          <CircularProgress
                            size={20}
                            className="text-primary"
                          />
                        ) : (
                          <EditIcon/>
                        )}
                      </button>
                    </>
                  )}
                </div>
              ),
            },
          ].filter(Boolean)}
        />
      ) : (
        <p>No sales found.</p>
      )}

      {totalPages > 0 && (
        <div className="d-flex justify-content-center mt-3">
          <ReactPaginate
            previousLabel={"← Previous"}
            nextLabel={"Next →"}
            breakLabel={"..."}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            pageRangeDisplayed={5}
            pageCount={totalPages}
            containerClassName="pagination"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            activeClassName="active"
            forcePage={currentPage}
          />
        </div>
      )}

      {!templateId && isViewTempModalOpen && (
        <InvoiceTempPreview
          isData={isViewData}
          onClose={() => setViewTempModalOpen(false)}
          onAdd={handleSetTemplate}
        />
      )}
      {templateId && isViewModalOpen && (
        <TemplateModalLayout
                isOpen={isViewModalOpen}
                isData={isViewData}
                onClose={handleClose}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                setSaleData={setViewData}
                isActive={isActive}
              />    
      )}
    </>
  );
};

export default ProjectListSale;
